var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "t-player__controller", on: { mouseup: _vm.mouseup } },
    [
      _c("div", { staticClass: "t-player__controls" }, [
        _c(
          "div",
          { staticClass: "t-player__controls-main" },
          [
            _c(
              "transition",
              { attrs: { name: "fade", mode: "out-in" } },
              [
                _vm.isPaused || _vm.isEnded
                  ? _c(
                      "t-button",
                      {
                        key: "play",
                        staticClass: "t-player__control",
                        attrs: { variant: "action" },
                        on: {
                          click: function ($event) {
                            return _vm.play()
                          },
                        },
                      },
                      [_c("i", { staticClass: "mdi mdi-play mdi-21px" })]
                    )
                  : _c(
                      "t-button",
                      {
                        key: "pause",
                        staticClass: "t-player__control",
                        attrs: { variant: "action" },
                        on: {
                          click: function ($event) {
                            return _vm.pause()
                          },
                        },
                      },
                      [_c("i", { staticClass: "mdi mdi-pause mdi-21px" })]
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "t-player__control",
                class: [
                  { "t-fs--subtitle": _vm.simple },
                  { "t-ff--mono": _vm.showMillis },
                ],
                staticStyle: { "margin-top": "1px" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.formattedCurrentTime) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "slider",
                staticClass: "t-player__slider",
                on: {
                  click: function ($event) {
                    return _vm.seek($event)
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "t-player__knob",
                  style: { width: _vm.width },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "t-player__scrubber",
                  style: { left: _vm.width },
                  on: { mousedown: _vm.mousedown, mouseup: _vm.mouseup },
                }),
                _vm._v(" "),
                !_vm.$isEmpty(_vm.quickJumpSteps)
                  ? _c(
                      "div",
                      { staticClass: "t-player__steps" },
                      _vm._l(_vm.quickJumpSteps, function (i, index) {
                        return _c("div", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: {
                                content: _vm.isChapter
                                  ? i.label
                                  : `Step ${index + 2}`,
                              },
                              expression:
                                "{\n              content: isChapter ? i.label : `Step ${index + 2}`\n            }",
                            },
                          ],
                          key: i.id,
                          staticClass: "t-player__step",
                          class: { "t-player__chapter": _vm.isChapter },
                          style: [
                            { left: _vm.step(i.startTime) },
                            { width: _vm.stepWidth(i) },
                          ],
                        })
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "t-player__controls-aside" },
          [
            !_vm.simple
              ? _c(
                  "div",
                  { staticClass: "t-player__subtitle-control t-mar--r-xs" },
                  [
                    !_vm.$isEmpty(_vm.subtitleTracks)
                      ? _c(
                          "t-button",
                          {
                            staticClass: "t-player__control t-mar--r-no",
                            attrs: { variant: "action" },
                            on: {
                              click: function ($event) {
                                _vm.subtitleTracks.length > 1 && !_vm.$isMobile
                                  ? _vm.showSubtitleTrackOptions()
                                  : _vm.toggleCaption()
                              },
                            },
                          },
                          [
                            _vm.subtitleLanguage
                              ? _c("i", {
                                  staticClass:
                                    "mdi mdi-closed-caption mdi-21px",
                                })
                              : _c("i", {
                                  staticClass:
                                    "mdi mdi-closed-caption-outline mdi-21px",
                                }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.showPopover
                          ? _c(
                              "div",
                              {
                                key: "popover",
                                staticClass:
                                  "t-popover t-popover--top t-popover--center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "t-popover__list" },
                                  [
                                    _vm._l(_vm.subtitleTracks, function (s) {
                                      return _c(
                                        "div",
                                        {
                                          key: s.id,
                                          staticClass:
                                            "t-popover__item t-cursor--pointer",
                                          class: {
                                            "t-popover__item--active":
                                              _vm.subtitleLanguage == s.lang,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setSubtitle(s)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(s.name) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        key: "off",
                                        staticClass:
                                          "t-popover__item t-cursor--pointer",
                                        class: {
                                          "t-popover__item--active":
                                            !_vm.subtitleLanguage,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSubtitle("")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("generic.text.off")) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-player__volume t-player__control" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [
                    _vm.isMuted
                      ? _c(
                          "t-button",
                          {
                            key: "volume-mute",
                            staticClass: "t-player__control",
                            attrs: { variant: "action" },
                            on: { click: _vm.unmute },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-volume-off mdi-21px",
                            }),
                          ]
                        )
                      : _c(
                          "t-button",
                          {
                            key: "volume-up",
                            staticClass: "t-player__control",
                            attrs: { variant: "action" },
                            on: { click: _vm.mute },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-volume-high mdi-21px",
                            }),
                          ]
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.simple
              ? [
                  _c(
                    "div",
                    { staticClass: "t-player__quality-control t-mar--r-xs" },
                    [
                      !_vm.$isEmpty(_vm.levels) && !_vm.$isMobile
                        ? _c(
                            "t-button",
                            {
                              staticClass: "t-player__control t-mar--r-no",
                              attrs: { variant: "action" },
                              on: {
                                click: function ($event) {
                                  return _vm.showLevels()
                                },
                              },
                            },
                            [_c("i", { staticClass: "mdi mdi-cog mdi-21px" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _vm.showLevelsPopover
                            ? _c(
                                "div",
                                {
                                  key: "popover",
                                  staticClass:
                                    "t-popover t-popover--top t-popover--center",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "t-popover__list" },
                                    _vm._l(_vm.levels, function (l) {
                                      return _c(
                                        "div",
                                        {
                                          key: l,
                                          staticClass:
                                            "t-popover__item t-cursor--pointer",
                                          class: {
                                            "t-popover__item--active":
                                              l == _vm.levels[_vm.level],
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setLevel(l)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(l) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "t-button",
                    {
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function ($event) {
                          return _vm.setPlaybackSpeed()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.playbackRate) +
                          "×\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      !_vm.isFullScreen
                        ? _c(
                            "t-button",
                            {
                              staticClass: "t-player__control",
                              attrs: { variant: "action" },
                              on: {
                                click: function ($event) {
                                  return _vm.enterFullScreen()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-fullscreen mdi-21px",
                              }),
                            ]
                          )
                        : _c(
                            "t-button",
                            {
                              staticClass: "t-player__control",
                              attrs: { variant: "action" },
                              on: {
                                click: function ($event) {
                                  return _vm.exitFullScreen()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-fullscreen-exit mdi-21px",
                              }),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.partnerMode && !_vm.removeTrainnBranding
                    ? _c(
                        "a",
                        {
                          staticClass: "t-player__control",
                          attrs: {
                            href: "https://trainn.co/",
                            target: "_blank",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/lib/assets/images/Trainn-Type-Assets/SVG/Trainn-type-mono.svg"),
                              height: "14px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }